import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Card, PageShell } from '../components/ui';

/**
 * Terms of Service page.
 * Static legal page — finalized March 2026.
 */
export default function TermsPage() {
  const { t } = useTranslation();

  return (
    <PageShell maxWidth="3xl" mainClassName="py-10">
      <h1 className="mb-8 text-3xl font-bold text-slate-900 dark:text-white">{t('legal.terms.title')}</h1>

      <Card className="prose max-w-none space-y-6 p-8 text-sm leading-relaxed text-slate-600 dark:prose-invert dark:text-slate-300">
        <p className="text-sm font-medium text-slate-600 dark:text-slate-400">{t('legal.terms.effectiveDate')}</p>
        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.terms.section1.title')}</h2>
          <p>{t('legal.terms.section1.body')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.terms.section2.title')}</h2>
          <ul className="list-disc space-y-1 pl-5">
            <li>{t('legal.terms.section2.items.accurate')}</li>
            <li>{t('legal.terms.section2.items.confidentiality')}</li>
            <li>{t('legal.terms.section2.items.noShare')}</li>
            <li>{t('legal.terms.section2.items.noUnauthorized')}</li>
            <li>{t('legal.terms.section2.items.compliance')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.terms.section3.title')}</h2>
          <p>{t('legal.terms.section3.p1')}</p>
          <p>{t('legal.terms.section3.p2')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.terms.section4.title')}</h2>
          <ul className="list-disc space-y-1 pl-5">
            <li>{t('legal.terms.section4.items.asIs')}</li>
            <li>{t('legal.terms.section4.items.noGuarantee')}</li>
            <li>{t('legal.terms.section4.items.noIndirect')}</li>
            <li>{t('legal.terms.section4.items.cap')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.terms.section5.title')}</h2>
          <p>
            <Trans
              i18nKey="legal.terms.section5.p1"
              components={{
                profileLink: <Link to="/profile" className="text-blue-600 hover:underline dark:text-blue-400" />,
                privacyLink: <Link to="/privacy" className="text-blue-600 hover:underline dark:text-blue-400" />,
              }}
            />
          </p>
          <p>{t('legal.terms.section5.p2')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.terms.section6.title')}</h2>
          <p>{t('legal.terms.section6.body')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.terms.section7.title')}</h2>
          <p>{t('legal.terms.section7.body')}</p>
        </section>

        <p className="border-t border-slate-200 pt-4 text-xs text-slate-400 dark:border-white/10 dark:text-slate-500">
          {t('legal.terms.lastUpdated')}
        </p>
      </Card>
    </PageShell>
  );
}
